export const SHEET_FIELDS = [
    {
        key: 'sheet.radius',
        label: '위 모서리 둥글기',
        help: '앱의 모든 바텀시트(정렬·필터·더보기·신고 등 아래에서 올라오는 창) 위쪽 두 모서리의 둥글기입니다. 기본은 지금 모양(앱 15px · 모바일 웹 8px)입니다.',
        group: '모양',
        type: 'enum',
        defaultValue: 'default',
        options: [
            { value: 'default', label: '기본 (앱 15px · 모바일 웹 8px)' },
            { value: 'xxs', label: 'xxs (2px)' },
            { value: 'xs', label: 'xs (4px)' },
            { value: 'xs-plus', label: 'xs-plus (6px)' },
            { value: 's', label: 's (8px)' },
            { value: 's-plus', label: 's-plus (10px)' },
            { value: 'm', label: 'm (12px)' },
            { value: 'm-plus', label: 'm-plus (16px)' },
            { value: 'l', label: 'l (20px)' },
            { value: 'xl', label: 'xl (32px)' },
        ],
    },
    {
        key: 'sheet.height',
        label: '기본 높이',
        help: '높이를 따로 정하지 않은 바텀시트가 화면 높이의 몇 %까지 올라오는지입니다. 내용 높이에 맞추는 시트와 높이를 직접 정한 시트(시청자 목록 등)는 바뀌지 않습니다.',
        group: '모양',
        type: 'integer',
        defaultValue: 85,
        min: 40,
        max: 95,
        unit: '%',
    },
    {
        key: 'sheet.handle.visible',
        label: '핸들 보이기',
        help: '바텀시트 맨 위 가운데의 작은 막대(핸들)를 그립니다. 핸들을 쓰는 시트에만 보이며, 끄면 모든 시트에서 핸들을 숨깁니다(시트를 끌어서 닫는 기능은 원래 없습니다).',
        group: '핸들',
        type: 'boolean',
        defaultValue: true,
    },
    {
        key: 'sheet.handle.width',
        label: '핸들 너비',
        help: '핸들 막대의 가로 길이입니다. 0이면 지금 크기(앱은 화면 너비의 7.5%, 모바일 웹은 36px)를 씁니다.',
        group: '핸들',
        type: 'integer',
        defaultValue: 0,
        min: 0,
        max: 120,
        unit: 'px',
    },
    {
        key: 'sheet.handle.height',
        label: '핸들 두께',
        help: '핸들 막대의 세로 두께입니다.',
        group: '핸들',
        type: 'integer',
        defaultValue: 4,
        min: 2,
        max: 12,
        unit: 'px',
    },
    {
        key: 'sheet.content.paddingX',
        label: '내용 좌우 여백',
        help: '바텀시트 안 내용과 시트 좌우 끝 사이의 여백입니다. 기본은 지금 여백(앱 14px · 모바일 웹 16px)입니다. 시트가 자기 여백을 따로 정한 경우는 그 값을 따릅니다.',
        group: '여백',
        type: 'enum',
        defaultValue: 'default',
        options: [
            { value: 'default', label: '기본 (앱 14px · 모바일 웹 16px)' },
            { value: 's', label: 's (8px)' },
            { value: 's-plus', label: 's-plus (10px)' },
            { value: 'm', label: 'm (12px)' },
            { value: 'm-plus', label: 'm-plus (16px)' },
            { value: 'l', label: 'l (20px)' },
            { value: 'l-plus', label: 'l-plus (24px)' },
            { value: 'xl', label: 'xl (32px)' },
        ],
    },
    {
        key: 'sheet.content.paddingBottom',
        label: '내용 아래 여백 추가',
        help: '바텀시트 내용 아래에 더할 여백입니다. 휴대폰 아래 안전 영역·키보드 높이만큼의 여백에 이 값이 더해집니다. 0이면 지금과 같습니다.',
        group: '여백',
        type: 'integer',
        defaultValue: 0,
        min: 0,
        max: 48,
        unit: 'px',
    },
    {
        key: 'sheet.backdrop.opacity',
        label: '뒤 화면 어둡기',
        help: '바텀시트가 열렸을 때 뒤 화면을 덮는 검은 막의 불투명도입니다. 0이면 어둡게 하지 않고, 클수록 어둡습니다.',
        group: '바탕',
        type: 'integer',
        defaultValue: 50,
        min: 0,
        max: 90,
        unit: '%',
    },
    {
        key: 'sheet.animation.duration',
        label: '열고 닫는 시간',
        help: '바텀시트가 아래에서 올라오고 내려가는 데 걸리는 시간입니다.',
        group: '바탕',
        type: 'integer',
        defaultValue: 300,
        min: 100,
        max: 1000,
        unit: 'ms',
    },
];
//# sourceMappingURL=sheet.js.map